import React, { useEffect, useRef, useState } from "react";
import MyEditor from "../Editor/Draft";
import "./style.css";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import ColorPicker from "../ColorPicker/ColorPicker";
import { useHistory } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ClientCreateDesign({ downloadNum }) {
  const history = useHistory();
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [open, setOpen] = useState(false);
  const [design, setDesign] = useState(0);
  const [title, setTitle] = useState("");
  const [titleMax, setTitleMax] = useState(50000);
  const [contentMax, setContentMax] = useState(500000);
  const [content, setContent] = useState("");
  const [logo, setLogo] = useState("");
  const [color, setColor] = useState("");
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [errMessage, setErrMessage] = useState(null);
  const [tLeng, setTLeng] = useState(0);
  const [dLeng, setDLeng] = useState(0);



  const handleClickOpen = ()=> {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    document.title = "Create a Design | Ski Design";
    handleClickOpen();
  }, []);
  // const [scroll, setScroll] = React.useState('paper');

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  // const descriptionElementRef = React.useRef(null);
  // React.useEffect(() => {
  //   if (open) {
  //     const { current: descriptionElement } = descriptionElementRef;
  //     if (descriptionElement !== null) {
  //       descriptionElement.focus();
  //     }
  //   }
  // }, [open]);

  const logoInput = useRef();
  const logoInput2 = useRef();
  const mainColorInput = useRef();

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      setLogo(URL.createObjectURL(img));
    }
  };

  const [oneImage, setOneImage] = useState("");
  const handleFile = (caller, e) => {
    setErrMessage(null);
    if (caller === "logo") setLogo("");
    else if (caller === "oneImage") setOneImage("");

    let tempFile = e.target.files[0];
    if (tempFile.size > 2097152 && caller === "logo") {
      setErrMessage({ type: "logo", msg: "Logo too big" });
      return;
    }
    if (tempFile.size > 5242880 && caller === "oneImage") {
      setErrMessage({
        type: "oneImage",
        msg: "Image is big. Choose another image.",
      });
      return;
    }
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      function () {
        caller === "oneImage"
          ? setOneImage(reader.result)
          : setLogo(reader.result);
      },
      false
    );

    if (tempFile) {
      reader.readAsDataURL(tempFile);
    }
  };

  const chooseDesigns = (e) => {
    e.preventDefault();
    let data = {
      design,
      title,
      content,
      logo,
      color,
      website,
      email,
      phone,
      cimg: oneImage,
    };
    history.push({
      pathname: "client-home/choose-your-design",
      state: {
        data,
        downloadNum,
      },
    });
  };

  const onTextChange = (e) => {
    if (e.target.name === "title") {
      if (e.target.value.split(" ").length > 20) {
        setTitleMax(e.target.value.length - 1);
        return;
      } else {
        if (titleMax < 50000) {
          setTitleMax(500000);
        }
        setTitle(e.target.value);
      }
      if (e.target.value === "") setTLeng(0);
      else setTLeng(e.target.value.split(" ").length);
    }
    if (e.target.name === "content") {
      if (e.target.value.split(" ").length > 30) {
        setContentMax(e.target.value.length - 1);
        return;
      } else {
        if (contentMax < 500000) {
          setContentMax(500000);
        }
        setContent(e.target.value);
      }
      if (e.target.value === "" || e.target.value === " ") setDLeng(0);
      setDLeng(e.target.value.split(" ").length);
    }
  };


  const [file, setFile] = useState(""),
    [colorBtnBg, setColorBtnBg] = useState("#ffffff");
  const uploadImage = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", "bt7sz20d");
    data.append("cloud_name", "yvesisite");
    fetch("https://api.cloudinary.com/v1_1/yvesisite/image/upload", {
      method: "post",
      body: data,
    })
      .then((res) => {
        return null;
      })
      .catch((err) => console.log(err));
  };
  return (
    <div className="dialog">
      <Dialog
        open={open}
        maxWidth={"md"} // 'sm' || 'md' || 'lg' || 'xl'
        TransitionComponent={Transition}
        keepMounted
        style={{borderRadius: 5}}
        onClose={handleClose}
        scroll={"body"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      > 
      
        <div className="create-design-container form-container">
         {/* <div className="upper-rotated-container"></div> */}
           <div className="create-design-cont form-cont">
           <h2 className="form-header">Create a Design</h2>
            <p className="under-header mb-3">
              Tell us, what you want Ski to design
            </p>
            <form className="d-flex flex-column align-items-center justify-content-center">
              <div class="form-group">
                <select
                  name="what-to-design"
                  className="what-to-design form-control"
                  id="#"
                  defaultValue="0"
                  value={design}
                  onChange={(e) => {
                    setDesign(e.target.value)
                    console.log(e.target.value)

                  }
                  }
                >
                  <option value="0" disabled>
                    What Do you Want to Design
                  </option>
                  <option value="fb">Facebook Post</option>
                  <option value="ig">Instagram Post</option>
                  <option value="tsap">Whatsapp Status Post</option>
                </select>
              </div>


              <div className="position-relative form-group">
                <small
                  className="position-absolute col-form-label"
                  style={{ right: 6, top: 12, color: "#696969" }}
                >
                  {tLeng}/10
                </small>
                <input
                  style={{ paddingTop: 7 }}
                  type="text"
                  required
                  placeholder="Add Header/Title"
                  className="title form-control my-2"
                  value={title}
                  name="title"
                  onChange={onTextChange}
                  maxLength={titleMax}
                />
              </div>
              {/* <MyEditor /> */}
              <div className="position-relative form-group">
                <small
                  className="position-absolute col-form-label"
                  style={{ right: 6, top: 20, color: "#696969" }}
                >
                  {dLeng}/12
                </small>
                <textarea
                  name="content"
                  placeholder="Add Any Further Content"
                  className="description my-2 form-control text-xs rounded text-black py-4 px-3 mt-3 rounded-sm border border-gray-300 focus:outline-none"
                  maxLength={contentMax}
                  value={content}
                  onChange={onTextChange}
                ></textarea>
              </div>
              <div className="d-flex justify-content-between form-group">
                <div className="inputGroup">
                  <div className="inputGrouping">
                    <div>
                      <input
                        style={{ cursor: "pointer" }}
                        onClick={() => logoInput?.current?.click()}
                        type="text"
                        readOnly
                        required
                        placeholder="Upload a Logo"
                        className="groupingChild"
                      />
                      <input
                        type="file"
                        name="logo"
                        ref={logoInput}
                        style={{ display: "none" }}
                        onChange={(e) => handleFile("logo", e)}
                      />
                      <input
                        type="file"
                        name="oneImage"
                        ref={logoInput2}
                        style={{ display: "none" }}
                        onChange={(e) => handleFile("oneImage", e)}
                      />
                      <img
                        src="/Images/upload-icon.png"
                        alt="Upload Icon"
                        onClick={() => logoInput?.current?.click()}
                      />
                    </div>
                      {errMessage && errMessage.type === "logo" && (
                      <div className="text-danger">
                        <small>{errMessage.msg}</small>
                      </div>
                      )}

                  </div>
                  
                  <div className="previewGrouping">
                    <div>Preview</div>
                    <div
                      style={{
                        backgroundImage:
                          logo !== ""
                            ? `url(${logo})`
                            : "url('/Images/placeholder-image.jpg')",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between form-group">
                <div className="inputGroup">
                  <div className="inputGrouping">
                    <div>
                      <input
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowColorPicker(true)}
                        onMouseOver={() => setShowColorPicker(false)}
                        type="text"
                        value="Choose Your Main Color"
                        readOnly
                        required
                        className="text-dark text-muted groupingChild"
                      />
                    </div>
                      {errMessage && errMessage.type === "oneImage" && (
                      <div className="text-danger">
                        <small>{errMessage.msg}</small>
                      </div>
                      )}
                  </div>

                  <div className="previewGrouping">
                    <div>Preview</div>
                    <div
                      className="previewColor"
                      style={{
                        background: colorBtnBg,
                        border: `1px solid ${colorBtnBg === "#ffffff" ? "#919191" : "#fff"
                          }`,
                      }}
                    ></div>
                    {showColorPicker && (
                    <ColorPicker
                      setColorBtnBg={setColorBtnBg}
                      setColor={setColor}
                    />
                    )}
                  </div>
                </div>


              </div>

              <input
                type="text"
                required
                placeholder="(Optional) Add website link"
                className="website-link my-2"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
              />
              <input
                type="email"
                required
                placeholder="(Optional) Add Email"
                className="contact my-2"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <input
                type="number"
                required
                placeholder="(Optional) phone Contact"
                className="contact my-2"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />

              <button
                className="position-relative my-3 create-design-btn submit-btn"
                type="submit"
                onClick={chooseDesigns}
              >
                Generate Design
              </button>
              <p className="already-have-acc w-75">
                It will only take 10 secs to get your design. You can Choose,
                Edit & Download!
              </p>
            </form>
          </div>
          {/* <div className="create-de-lower-rotated lower-rotated-container"></div> */}
        </div>
      </Dialog>
    </div>
  );
}

export default ClientCreateDesign;
